import React, { type FC, type PropsWithChildren, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAuth } from 'components/Auth';
import { moment } from './momentRangeSetup';
import { useTranslation } from 'react-i18next';

export const MomentProvider: FC<PropsWithChildren> = (props) => {
    const { effectiveProviderData } = useAuth();
    const { i18n } = useTranslation();

    const providerTimezone = effectiveProviderData?.timeZone ?? '';

    useEffect(() => {
        moment.tz.setDefault(providerTimezone);
    }, [providerTimezone]);

    useEffect(() => {
        moment.locale(i18n.language?.toLowerCase() || 'en');
    }, [i18n.language]);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={i18n.language}>
            {props.children}
        </LocalizationProvider>
    )
};
